import React from "react";

import { Group, Stepper, Text } from "@mantine/core";

export const StepperStylesheet = () => (
  <>
    <Group grow wrap="wrap">
      <Stepper active={1} mb="xl" my="lg">
        <Stepper.Step label="1" description="Choose a template">
          <Text mb="md">Step 1 content goes here</Text>
        </Stepper.Step>
        <Stepper.Step label="2" description="Customise">
          <Text mb="md">Step 2 content goes here</Text>
        </Stepper.Step>
        <Stepper.Step label="3" description="Link to Moments">
          <Text mb="md">Step 3 content goes here</Text>
        </Stepper.Step>
        <Stepper.Completed>
          <Text mb="md">All steps completed - you&apos;re finished</Text>
        </Stepper.Completed>
      </Stepper>
    </Group>
    <Group wrap="wrap">
      <Stepper variant="no-lines" active={1} mb="xl" my="lg" size="sm">
        <Stepper.Step>
          <Text mb="md">Step 1 content goes here</Text>
        </Stepper.Step>
        <Stepper.Step>
          <Text mb="md">Step 2 content goes here</Text>
        </Stepper.Step>
        <Stepper.Step>
          <Text mb="md">Step 3 content goes here</Text>
        </Stepper.Step>
        <Stepper.Completed>
          <Text mb="md">All steps completed - you&apos;re finished</Text>
        </Stepper.Completed>
      </Stepper>
    </Group>
  </>
);
